import { render, staticRenderFns } from "./ediLogSummary.vue?vue&type=template&id=922151fa&"
import script from "./ediLogSummary.vue?vue&type=script&lang=js&"
export * from "./ediLogSummary.vue?vue&type=script&lang=js&"
import style0 from "./ediLogSummary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports